// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__34heJ","inner":"Form_inner__X7kiB","range":"Form_range__2IWVU","name":"Form_name__YYjvt","actions":"Form_actions__3wxt6"};